<template>
  <div class="contact">
    <a-form :form="form" :label-col="{ xs: 6 }" :wrapper-col="{ xs: 18 }" colon hide-required-mark class="form" @submit="handleSubmit">
      <a-form-item label="公司名称">
        <a-input
          v-decorator="['company', { rules: [{ required: true, message: '请输入公司名称!' }] }]"
          placeholder="公司名称与营业执照一致"
        />
      </a-form-item>
      <a-form-item label="联系人">
        <a-input
          v-decorator="['name', { rules: [{ required: true, message: '请输入联系人姓名!' }] }]"
          placeholder="请输入联系人姓名"
        />
      </a-form-item>
      <a-form-item label="联系电话">
        <a-input
          v-decorator="['phone', { rules: [{
            required: true,
            message: '请输入手机号!'
          }, {
            validator: checktelphone,
          }] }]"
          placeholder="请输入手机号"
        />
      </a-form-item>
      <a-form-item label="手机验证码">
        <a-input-search
          v-decorator="['verifyCode', { rules: [{ required: true, message: '请输入短信验证码!' }] }]"
          placeholder="短信验证码"
          size="large"
          @search="getVerificationCode"
        >
          <a-button slot="enterButton" :disabled="!isShowGetCode">
            <template v-if="isShowGetCode">获取验证码</template>
            <template v-else>{{ countdown }}s后可重试</template>
          </a-button>
        </a-input-search>
      </a-form-item>
      <a-form-item label="所在城市">
        <a-input
          v-decorator="['address']"
          placeholder="请输入所在城市"
        />
      </a-form-item>
      <a-form-item label="目前行业">
        <a-input
          v-decorator="['industry']"
          placeholder="请输入行业"
        />
      </a-form-item>
      <a-form-item :wrapper-col="{ xs: 24}">
        <a-button type="primary" html-type="submit" class="submit-btn">
          信息提交
        </a-button>
      </a-form-item>
    </a-form>
    <div id="captcha" />
  </div>
</template>

<script>
import { sendSmsCaptcha, informationCollection } from '@/apis/index'
export default {
  props: {
    infoSources: {
      type: String,
      default: '渠道合作'
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      captcha: null,
      countdown: 60,
      timer: '',
      isShowGetCode: true,
      captchaIns: null,
      params: null
    }
  },
  mounted() {
    this.getCode()
  },
  methods: {
    userError() {
      const { getFieldError } = this.form
      return getFieldError('phone') || getFieldError('verifyCode')
    },
    checktelphone(rule, value, callback) {
      const reg = /^1[3456789]\d{9}$/
      if (value && !(reg.test(value))) {
        callback('请输入正确的手机号码！')
      } else {
        callback()
      }
    },
    // 模拟锚点跳转
    goAnchor(selector) { // 参数selector是id选择器（#anchor14）
      document.querySelector(selector).scrollIntoView({
        behavior: 'smooth'
      })
    },
    getVerificationCode() {
      this.form.validateFields(['imgCaptcha', 'phone'], (errors, values) => {
        if (!errors) {
          this.params = values
          this.captchaIns.popUp()
        }
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            infoSources: this.infoSources,
            officialWebsiteEntrance: '公众号',
            address: values.address,
            name: values.name,
            phone: values.phone,
            verifyCode: values.verifyCode,
            company: values.company,
            industry: values.industry
          }
          informationCollection(params).then(res => {
            this.$message.success({
              content: '感谢您的信息提交，我们将会有专员与您联系~',
              duration: 1
            })
            this.captchaIns.refresh()
            this.form.resetFields()
            this.$emit('cancel', false)
          }).catch(err => {
            this.$message.error(err)
            this.captchaIns.refresh()
          })
        }
      })
    },
    countDown() {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
          self.captchaIns.refresh()
        }
      }, 1000)
    },
    getCode() {
      const that = this
      // eslint-disable-next-line no-undef
      initNECaptcha && initNECaptcha({
        element: '#captcha',
        captchaId: '6c0483e901164a789d9d13f0291ba257',
        mode: 'popup',
        width: '320px',
        // enableClose: true,
        onClose: function() {
          // 弹出关闭结束后将会触发该函数
        },
        onVerify: function(err, data) {
          if (err) return
          // that.captchaIns.close()
          that.params.pictureCode = data.validate
          sendSmsCaptcha(that.params).then(data => {
            that.countDown()
            that.isShowGetCode = false
          }).catch(err => {
            that.$message.error(err)
            that.captchaIns.refresh()
          })
        }
      }, function(instance) {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        that.captchaIns = instance
      }, function(err) {
        console.log(err)
        // 初始化失败后触发该函数，err对象描述当前错误信息
      })
    }
  }
}
</script>

<style lang="less" scoped>
 .contact {
    padding: 0 16px 24px;
    .form {
      width: 343px;
      .label {
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 28px;
        text-align: right;
        padding: 5px 10px 5px 0;
      }
      /deep/ .ant-form-item {
        margin-bottom: 4px;
      }
      /deep/ .ant-form-item-label {
        width: 25%;
        text-align: right;
        padding-right: 10px;
        line-height: 40px;
      }
      /deep/ .ant-form-item-control-wrapper {
        width: 75%;
      }
      /deep/ .ant-form-item-label > label {
        color: #FFFFFF;
      }
      /deep/ .ant-input {
        height: 40px;
        font-size: 14px;
        font-weight: 400;
      }
      /deep/ .ant-btn:hover, .ant-btn:focus {
        border-color: #FF8C24;
      }
      /deep/ .ant-btn-primary {
        width: 343px;
        height: 40px;
        line-height: 44px;
        background: #FF8C24;
        border-color: #FF8C24;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
      }
      /deep/ .ant-input-group-addon .ant-btn-lg {
        width: 118px;
        height: 40px;
        padding: 6px 0;
      }
      .imgCaptcha {
        display: inline-block;
        width: 90px;
        height: 28px;
        margin: 0 3px;
      }
      .reload {
        color: #fff;
        cursor: pointer;
        line-height: 40px;
        // margin-left: 20px;
      }
    }
  }
</style>
